import { render, staticRenderFns } from "./Buffet.vue?vue&type=template&id=73f5fa7a&scoped=true&"
import script from "./Buffet.vue?vue&type=script&lang=js&"
export * from "./Buffet.vue?vue&type=script&lang=js&"
import style0 from "./Buffet.vue?vue&type=style&index=0&id=73f5fa7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5fa7a",
  null
  
)

export default component.exports